import { config } from "../../config";
import axios from "axios";
import moment from "moment";

import { LocalStorage } from '@/data/localstorage';
import { User } from '../../entity/authentication/user';
import { CorporateDetails,BranchStatus,ChargerOverallStatus,ChargerOtherStatus, UserBranchRelationshipStatus, UserTariffType } from '../../entity/corporate/corporateDetails';
import { CorporateAddressTransformer } from '../../service/transformers/corporate';
import { QueryInfo } from "@/util";
import { EVCStationStatus } from "../../entity/location/evcstation";
import { EVChargingReservation, EVChargingReservationStatus } from '@/entity/station/reservation';
import { EVChargingReservationTransformer } from '../transformers/evcreservation';
import { Result } from '..';
import { jsx } from "vue/jsx-runtime";

export interface CpoReservationQuery {
    id?: string
    station?: {
        name?: string
    }
    corporate?: {
        name?: string
    }
    branch?: {
        name?:string
    }
    reservedBetween?: {
        from?: Date,
        to?: Date
    }
    status?: EVChargingReservationStatus
    mobile?: string
}

export interface CorporateQuery {
    id?: string
    corporateName?: string
    branch?: string
    gstNumber?: string
    status?: string
}
export interface BranchStationQuery {
    corporateId: string
    corporateName: string
    branchId: string
    branch: string  
    stationName?: string
    city?: string
    status?: EVCStationStatus  
}

export interface BranchUserQuery {
    id?: string
    mobileOrEmail?: string
    status?: string
    tariffType ? : string
}

export interface ChargerOutputDetails {
    installationId: number;
    outputId: string;
    outputName: string;
    outputNumber: number;
}

export interface chargerStatusQuery {
    branchId: string
    stationId: string
    outputId: string
    outputDetails ?: ChargerOutputDetails | null
}

export interface chargerStatusforReportQuery {
    branchId: string
    stationId: string
}

export interface chargerOutputListforReportQuery {
    branchId: string
    stationId: string
    chargerId: string
}

export interface adminDashboardQuery {
    branchId: string
    stationId: string
    outputId: string
    filterId : string
    fyYear: string
    fyMonth: string
}

export interface customerVisitQuery {
    branchId: string
    stationId: string
    outputId: string
    filterId : string
    fyYear : string
    fyMonth : string
}

export interface financialMonthQuery {
    fyYear: string
}

export interface ViewUserInfo {
    id?: string
    mobileOrEmail?: string
    status?: string
    effectiveFrom ? : string
    effectiveTo?: string
}

export interface AdminBranchQuery {
    installationId: string
    outputId: string
    connectorID: string
}

export interface UsageReportQuery {
    mobile? : string,
    branchId: string,
    fromDate: string,
    toDate: string,
    reportTypeCode: string,
    vehicleNo?: string,
    stationId: string,
    chargerId: string
    outputId: string,
    chargerType: string,
    outputName: string
    branchName: string,
    stationName: string
}

export interface reportDetailsQuery {
    branchId: string,
    stationId: string,
}

export interface TransactionReportQuery {
    branchId: string,
    reportCode: string,
    reportId: string,
    fromDate: string,
    toDate: string,
    branchName: string,
    stationName: string,
    stationId: string,
    chargerId: string
    outputId: string
    chargerType: string,
    outputName: string,
    errorCode: string
}

export class CorporateService {
    async getCorporates(): Promise<any> {
        let chargerTypes = [];
        let response = await axios.get(config.api.host + "/corporate/getCorporates", {
            headers: {
                Authorization : new LocalStorage().authToken
            }
        })
        let corporateTypesInfos: any[] = response.data.data
        corporateTypesInfos.forEach(corporate => {
            chargerTypes.push(corporate)
        });
        return Promise.resolve(corporateTypesInfos)
    }

    async getBranchStatus(): Promise<BranchStatus[]> {
        let response = await axios.get(config.api.host + "/corporate/branchStatus", {
            headers: {
                Authorization : new LocalStorage().authToken
            }
        });
        let statusInfos: any[] = response.data.data;
        let statuses: BranchStatus[] = [];
        statusInfos.forEach((statusInfo) => {
            statuses.push(new BranchStatus(
                statusInfo.code,
                statusInfo.description,
                "",
                ""
            ))
        });
        return Promise.resolve(statuses);

    }
    async getUserBranchRelationshipStatus(): Promise<UserBranchRelationshipStatus[]> {
        let response = await axios.get(config.api.host + "/corporate/userBranchRelationshipStatus", {
            headers: {
                Authorization : new LocalStorage().authToken
            }
        });
        let statusInfos: any[] = response.data.data;
        let statuses: UserBranchRelationshipStatus[] = [];
        statusInfos.forEach((statusInfo) => {
            statuses.push(new UserBranchRelationshipStatus(
                statusInfo.code,
                statusInfo.description,
                "",
                ""
            ))
        });
        return Promise.resolve(statuses);

    }
    async createBranchDetailsByAuthor(corporateDetails: CorporateDetails, user: User): Promise<any> {
     
        let corporateInfo = {
            userId: user.id,
            corporateDetails
        }

        await axios.post(config.api.host + "/corporate/addBranchDetails", {
            data: corporateInfo
        }, {
            headers: {
                Authorization : new LocalStorage().authToken
            }
        })
        return Promise.resolve()
    }
    async updateBranchDetailsByAuthor(corporateDetails: CorporateDetails, user: User): Promise<any> {
    
        let corporateInfo = {
            userId: user.id,
            corporateDetails
        }
        
        await axios.put(config.api.host + "/corporate/saveBranchDetails", {
            data: corporateInfo
        }, {
            headers: {
                Authorization : new LocalStorage().authToken
            }
        })
        return Promise.resolve()
    }
    async getCorporateDetails(user: User): Promise<CorporateDetails> {        
        let response = await axios.get(config.api.host + "/corporate/" + user.id + "/corporateDetails", {
            headers: {
                'Authorization' : window.localStorage.getItem("user.token")
            }
        })
        let profileInfo: any = response.data.data
        let corporateInfo = new CorporateDetails(
            profileInfo.corporateName,
            profileInfo.branch,
            profileInfo.mobile1,
            profileInfo.primaryContactPerson,
            profileInfo.gstNumber,
            profileInfo.email,
            profileInfo.email2,
            profileInfo.email3,
            profileInfo.status,
            profileInfo.mobile2,
            profileInfo.faxNumber,
            profileInfo.secondaryContactPerson,
            new CorporateAddressTransformer().transform(profileInfo),
        )
        return Promise.resolve(corporateInfo)
    }

    async corporateEditPermission(): Promise<any> {
        let response = await axios.get(config.api.host + "/corporate/"+1+"/corporateEditPermission/"+"90|L", {
            headers: {
                'Authorization' : window.localStorage.getItem("user.token")
            }
        });
        return Promise.resolve(response.data)
    }

    async corporateAtPageByPaginatedWithSizeMatchingQuery(page: number, size: number, query?: CorporateQuery): Promise<any> {
        let queryInfo: any = {
            page: page,
            "page-size" : size
        }
        if(query) {
            if(query.corporateName) {
                queryInfo = {... queryInfo,
                    corporateName: query.corporateName

                }
            }
            if(query.id) {
                queryInfo = {... queryInfo,
                    branchId: query.id

                }
            }
            if(query.branch) {
                queryInfo = {... queryInfo,
                    branch: query.branch
                }
            }
            if(query.status) {
                queryInfo = {... queryInfo,
                    status: query.status
                }
            }
        }
        let response = await axios.get(config.api.host + "/corporate/searchBranch" + new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }
    async cpoBranchAtPageByPaginatedWithSizeMatchingQuery(page: number, size: number, userId: string, query?: CorporateQuery): Promise<any> {
        let queryInfo: any = {
            page: page,
            "page-size" : size,
            userId: userId
        }
        if(query) {
            if(query.corporateName) {
                queryInfo = {... queryInfo,
                    corporateName: query.corporateName

                }
            }
            if(query.id) {
                queryInfo = {... queryInfo,
                    branchId: query.id

                }
            }
            if(query.branch) {
                queryInfo = {... queryInfo,
                    branch: query.branch
                }
            }
        }
        let response = await axios.get(config.api.host + "/corporate/searchCPOBranch" + new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }
    async cpoChargingStationsAtPageByPaginatedWithSizeMatchingQuery(page: number, size: number, query?: BranchStationQuery): Promise<any> {
        let queryInfo: any = {
            page: page,
            "page-size" : size,
            userId: localStorage.getItem("user.id")
        }
        
        if(query) {
            if(query.corporateId) {
                queryInfo = {...queryInfo,
                    corporateId: query.corporateId
            
                }
            }
            if(query.corporateName) {
                queryInfo = {... queryInfo,
                    corporateName: query.corporateName

                }
            }
            if(query.branchId) {
                queryInfo = {... queryInfo,
                    branchId: query.branchId

                }
            }
            if(query.branch) {
                queryInfo = {... queryInfo,
                    branch: query.branch
                }
            }
            if(query.stationName) {
                queryInfo = {... queryInfo,
                    stationName: query.stationName
                }
            }
            if(query.city) {
                queryInfo = {... queryInfo,
                    city: query.city
                }
            }
            if(query.status) {
                queryInfo = {... queryInfo,
                    status: query.status.id
                }
            }
        }
        let response = await axios.get(config.api.host + "/corporate/searchBranchStations" + new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }
    async getBranchDetailsById(id: string): Promise<any> {
        let response = await axios.get(config.api.host + "/corporate/" + id, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        let corporateInfo = response.data.data;
        // let corporate = new CorporateAddressTransformer().transform(corporateInfo);
        return Promise.resolve(corporateInfo);
    }
    async viewAssociatedUserInfo(mobile: string, branchId: number): Promise<any> {
        let response = await axios.get(config.api.host + "/corporate/viewAssociatedUserDetails/" + mobile+"/"+branchId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        let corporateInfo = response.data;
        // let corporate = new CorporateAddressTransformer().transform(corporateInfo);
        return Promise.resolve(corporateInfo);
    }

    // async viewAssociatedUserInfo(mobile: string, branchId: number, query?: ViewUserInfo): Promise<any> {
    //     let queryInfo: any = {
            
    //     }

    //     if(query) {
    //         if(query.id) {
    //             queryInfo = {... queryInfo,
    //                 branchId: query.id

    //             }
    //         }
            
    //         if(query.mobileOrEmail) {
    //             queryInfo = {... queryInfo,
    //                 mobileOrEmail: query.mobileOrEmail
    //             }
    //         }
    //         if(query.status) {
    //             queryInfo = {...queryInfo,
    //                 status: query.status

    //             }
    //         }
    //         if(query.effectiveFrom) {
    //             queryInfo = {...queryInfo,
    //                 effectiveFrom: query.effectiveFrom
    //             }
    //         }
    //         if(query.effectiveTo) {
    //             queryInfo = {...queryInfo,
    //                 effectiveTo: query.effectiveTo
    //             }
    //         }
    //     }
    //     let response = await axios.get(config.api.host + "/corporate/viewAssociatedUserDetails/" + mobile+"/"+branchId, {
    //         headers: {
    //             Authorization: new LocalStorage().authToken
    //         }
    //     })
    //     let corporateInfo = response.data;
    //     // let corporate = new CorporateAddressTransformer().transform(corporateInfo);
    //     return Promise.resolve(corporateInfo);
    // }
    
    async userBranchRelationshipAtPageByPaginatedWithSizeMatchingQuery(page: number, size: number, query?: BranchUserQuery): Promise<any> {
        let queryInfo: any = {
            page: page,
            "page-size" : size
        }

        if(query) {
            if(query.id) {
                queryInfo = {... queryInfo,
                    branchId: query.id

                }
            }
            
            if(query.mobileOrEmail) {
                queryInfo = {... queryInfo,
                    mobileOrEmail: query.mobileOrEmail
                }
            }
            if(query.status) {
                queryInfo = {...queryInfo,
                    status: query.status

                }
            }
            if(query.tariffType) {
                queryInfo = {...queryInfo,
                    tariffType: query.tariffType

                }
            }
        }
        let response = await axios.get(config.api.host + "/corporate/searchUserBranchRelationship" + new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }

    async deleteUserFromBranchRelationship(branchId: string, userId: string, relationshipId: string): Promise<any> {
        let loginUserId =  localStorage.getItem("user.id")
        let response = await axios.put(config.api.host + "/corporate/"+loginUserId+"/deleteUserBranchRelationship", {
            data: {
                branchId: branchId,
                userId: userId,
                relationshipId:relationshipId
               }
        }, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        });
        
        return Promise.resolve(response.data)
    }

    async getUserInfoByMobileOrEmail(userInfo: string, branchId: string): Promise<any> {
        let response = await axios.get(config.api.host + "/corporate/getUserInfoForBanch/"+ userInfo+"/"+branchId,{
            headers: {
                Authorization: new LocalStorage().authToken
            }
        });
        return Promise.resolve(response.data);
    }

    // Get Users Type Details
    async getUserTypes(): Promise<UserTariffType[]> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/v1/corporate/" + userId +"/userTypeForUserAssociation",{
            headers: {
                Authorization: new LocalStorage().authToken
            }
        });
         let tariffInfo: any[] = response.data.data;
        let tariffTypes: UserTariffType[] = [];
        tariffInfo.forEach((tariffType) => {
            tariffTypes.push(new UserTariffType(
                tariffType.code,
                tariffType.description,
                "",
                ""
            ))
        });
        return Promise.resolve(tariffTypes);
    }


    async addUserInfoWithBranch(branchId: string, userId: string, tariffTypeCode: String): Promise<any> {
        let response = await axios.post(config.api.host + "/corporate/addUserInfoWithBranch",{
            data: {
                userId: userId,
                branchId: branchId,
                tariffTypeCode: tariffTypeCode
            }
        },
        {
            headers: {
                Authorization: new LocalStorage().authToken
            } 
        });
        return Promise.resolve(response.data);
    }

    async saveTariffTypeForUserAssociation(branchId: string,userId: string, tariffTypeCode: String, relationshipId: string): Promise<any> {
        let loginUserId =  localStorage.getItem("user.id");
        let response = await axios.post(config.api.host + "/v1/corporate/" + loginUserId + "/saveTariffTypeForUserAssociation",{
            data: {
                userId: userId,
                branchId: branchId,
                tariffType: tariffTypeCode,
                relationshipId: relationshipId
            }
        },
        {
            headers: {
                Authorization: new LocalStorage().authToken
            } 
        });
        return Promise.resolve(response.data);
    }
    
    
    async cpoReservationsAccessibleByCPOUserAtPageByPaginatedWithSizeMatchingQuery(user: User, page: number, size: number, query: CpoReservationQuery): Promise<Result<EVChargingReservation>> {
        let queryInfo: any = {
            page: page,
            "page-size": size
        }
        
        if (query.station && query.station.name) {
            queryInfo = {
                ...queryInfo,
                stationName: query.station.name
            }
        }
        if (query.id) {
            queryInfo = {
                ...queryInfo,
                reservationNo: query.id
            }
        }
        if (query.branch && query.branch.name) {
            queryInfo = {
                ...queryInfo,
                branchName: query.branch.name
            }
        }
        if (query.corporate && query.corporate.name) {
            queryInfo = {
                ...queryInfo,
                corporateName: query.corporate.name
            }
        }
        if (query.reservedBetween) {
            if (query.reservedBetween.from) {
                queryInfo = {
                    ...queryInfo,
                    reservedFrom: moment(query.reservedBetween.from).format("YYYY-MM-DD")
                }
            }
            if (query.reservedBetween.to) {
                queryInfo = {
                    ...queryInfo,
                    reservedTo: moment(query.reservedBetween.to).format("YYYY-MM-DD")
                }
            }
        }
        
        if (query.status) {
            queryInfo = {
                ...queryInfo,
                status: {
                    code: query.status.id
                }
            }
        }
        if (query.mobile) {
            queryInfo = {
                ...queryInfo,
                customerMobile: query.mobile
            }
        }
        
        
        let response = await axios.get(config.api.host + "/corporate/"+user.id+"/searchCpoReservations" + new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        }
        )
        let reservationsInfos: any[] = response.data.data
        var reservations: any = [];
        reservationsInfos.forEach(reservationInfo => {
            reservations.push({
                "reservationId" : reservationInfo.reservationId,
                "corporateName" : reservationInfo.corporateName,
                "branchName" : reservationInfo.branchName,
                "stationName" : reservationInfo.installationDetail.station.stationName,
                "userName" : reservationInfo.user.firstName + (reservationInfo.user.lastName != null ? reservationInfo.user.lastName : ""),
                "mobile" : reservationInfo.mobile,
                "reservationDate" : reservationInfo.actualStartTimeText,
                "invoiceNumber" :reservationInfo.invoiceNumber, 
                "invoiceTotal" : reservationInfo.actualNettCost,
                "invoiceDate" : reservationInfo.invoiceDate,
                "invoiceKwh" : reservationInfo.unitsConsumed,
                "status" : reservationInfo.status,
                "refNo" : reservationInfo.reservationNo
                
            })
        })
        // let reservations: EVChargingReservation[] = []
        // reservationsInfos.forEach(reservationInfo => {
        //     let stationInfo: any = reservationInfo.station
        //     reservations.push(new EVChargingReservationTransformer().transform(reservationInfo))
        // });
        // console.log(JSON.stringify(reservations))
        // return Promise.resolve(new Result<EVChargingReservation>(response.data.meta.totalrecords, reservations))
        return Promise.resolve(new Result(response.data.meta.totalrecords, reservations))
    }
    
    async getCPOCharInfo(): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/corporate/"+userId+"/dashboardChargerStatus", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data.data)
    }

    async getBranchList(): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/corporate/"+userId+"/getBranchListForDashboard", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }

    async getDashboardList(): Promise<any> {
        let userId =  localStorage.getItem("user.id");
        let roleId = localStorage.getItem("user.roleId")
        let response = await axios.get(config.api.host + "/v1/admin/"+userId+"/getDashboardList/"+roleId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }

    async getBranchId(): Promise<any> {
        let userId =  localStorage.getItem("user.id");
        let response = await axios.get(config.api.host + "/v1/admin/"+ userId +"/branchList", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data.data.branchList)
    }

    async getFilterType(): Promise<any> {
        let userId =  localStorage.getItem("user.id");
        let response = await axios.get(config.api.host + "/v1/admin/"+ userId +"/filterTypeForUsageDashboard", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data.data.filterType)
    }

    async getStationList(branchId: any): Promise<any> {
        let userId =  localStorage.getItem("user.id");
        let response = await axios.get(config.api.host + "/v1/admin/"+ userId +"/stationsList/"+branchId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data.data.stationsList)
    }

    async getAdminionList(): Promise<any> {
        let userId =  localStorage.getItem("user.id");
        let response = await axios.get(config.api.host + "/v1/admin/"+ userId +"/userManagementOption", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }

    async getFinancialYears(): Promise<any> {
        let userId =  localStorage.getItem("user.id");
        let response = await axios.get(config.api.host + "/v1/admin/"+ userId +"/financialYears",{
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data.data.financialYear)
    }

    async getFinancialMonths(query: financialMonthQuery): Promise<any> {
        let queryInfo: any = {

        }
        if(query) {
            if(query.fyYear != null) {
                queryInfo = {... queryInfo,
                    fyYear: query.fyYear

                }
            }
        }
        let userId =  localStorage.getItem("user.id");
        let response = await axios.get(config.api.host + "/v1/admin/"+ userId +"/financialMonths", {
            params: queryInfo,
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data.data.financialMonths)
    }

    async getOutputList(branchId: any, stationId: any): Promise<any> {
        let userId =  localStorage.getItem("user.id");
        let response = await axios.get(config.api.host + "/v1/admin/"+ userId +"/outputsList/"+ branchId + "/" + stationId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data.data.portsList)
    }

    async getTypesOfReport(): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/v1/corporate/"+userId+"/reportTypeForUsageReport", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }

    async getChargerStatusDataForReport(query: chargerStatusforReportQuery): Promise<any> {
        let queryInfo: any = {

        }
        if(query) {
            if(query.branchId != null) {
                queryInfo = {... queryInfo,
                    branchId: query.branchId

                }
            }
            
            if(query.stationId != null) {
                queryInfo = {... queryInfo,
                    stationId: query.stationId
                }
            }
        }
        let userId =  localStorage.getItem("user.id");
        let response = await axios.get(config.api.host + "/v1/corporate/" + userId + "/getChargersList" + new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        
        return Promise.resolve(response.data.data)
    }

    async getChargerOutputListForReport(query: chargerOutputListforReportQuery): Promise<any> {
        let queryInfo: any = {

        }
        if(query) {
            if(query.branchId != null) {
                queryInfo = {... queryInfo,
                    branchId: query.branchId

                }
            }
            
            if(query.stationId != null) {
                queryInfo = {... queryInfo,
                    stationId: query.stationId
                }
            }
            if(query.chargerId != null) {
                queryInfo = {... queryInfo,
                    chargerId: query.chargerId
                }
            }
        }
        let userId =  localStorage.getItem("user.id");
        let response = await axios.get(config.api.host + "/v1/corporate/" + userId + "/getOutputList" + new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        
        return Promise.resolve(response.data.data)
    }

    async getStationDetails(): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/v1/corporate/"+userId+"/getStationDetails", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }

    async getChargerDetails(): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/v1/corporate/"+userId+"/getChargerDetails", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }

    async getBranchListForReport(): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/corporate/"+userId+"/branchList", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }
    async getBranchChargerStatus(branchId: any): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/corporate/"+userId+"/getBranchChargerStatus/"+branchId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }
    async getOverAllBranchChargerStatus(): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/corporate/"+userId+"/getBranchOverAllChargerStatus", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }
    async getCorbonIndexUsage(branchId: any): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/corporate/"+userId+"/getUsageChartData/"+branchId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        
        return Promise.resolve(response.data.data)
    }
    // async getChargerStatusDataForDashboard(branchId: any): Promise<any> {
    //     let userId =  localStorage.getItem("user.id")
    //     if(branchId != '') {
    //         let response = await axios.get(config.api.host + "/admin/getChargerStatusForDashboard/"+userId+"/"+branchId, {
    //             headers: {
    //                 Authorization: new LocalStorage().authToken
    //             }
    //         })
            
    //         return Promise.resolve(response.data)
    //     } else {
    //         let response = await axios.get(config.api.host + "/admin/getChargerStatusForDashboard/"+userId, {
    //             headers: {
    //                 Authorization: new LocalStorage().authToken
    //             }
    //         })
            
    //         return Promise.resolve(response.data)
    //     }
        
    // }
    async getChargerStatusDataForDashboard(query: chargerStatusQuery): Promise<any> {
        let queryInfo: any = {

        }
        if(query) {
            if(query.branchId != null) {
                queryInfo = {... queryInfo,
                    branchId: query.branchId

                }
            }
            
            if(query.stationId != null) {
                queryInfo = {... queryInfo,
                    stationId: query.stationId
                }
            }
            if(query.outputId !== undefined) {
                queryInfo = {...queryInfo,
                    outputId: query.outputId

                }
                if(query.outputId != "0") {
                    queryInfo = {... queryInfo,
                        outputDetails : query.outputDetails

                    }
                }
            }
        
        }
        let userId =  localStorage.getItem("user.id");
        let response = await axios.get(config.api.host + "/admin/getChargerStatusForDashboard/"+ userId + new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        
        return Promise.resolve(response.data)
    }
        
    // async getGreenHousGasUsageForDashboard(branchId: any): Promise<any> {
    //     let userId =  localStorage.getItem("user.id")
    //     if(branchId != "") {
    //         let response = await axios.get(config.api.host + "/admin/consumedGHGForAdminDashboard/"+userId+"/"+branchId, {
    //             headers: {
    //                 Authorization: new LocalStorage().authToken
    //             }
    //         })
            
    //         return Promise.resolve(response.data)
    //     } else {
    //         let response = await axios.get(config.api.host + "/admin/consumedGHGForAdminDashboard/"+userId+"/"+branchId, {
    //             headers: {
    //                 Authorization: new LocalStorage().authToken
    //             }
    //         })
            
    //         return Promise.resolve(response.data)
    //     }
        
    // }

    async getGreenHousGasUsageForDashboard(query: adminDashboardQuery): Promise<any> {
        let queryInfo: any = {

        }
        if(query) {
            if(query.branchId != null) {
                queryInfo = {... queryInfo,
                    branchId: query.branchId

                }
            }
            
            if(query.stationId != null) {
                queryInfo = {... queryInfo,
                    stationId: query.stationId
                }
            }
            if(query.outputId != null) {
                queryInfo = {...queryInfo,
                    outputId: query.outputId

                }
            }
            if(query.filterId != null) {
                queryInfo = {...queryInfo,
                    filterId: query.filterId

                }
            }
            if(query.fyYear != null) {
                queryInfo = {...queryInfo,
                    fyYear: query.fyYear

                }
            }
            if(query.fyMonth != null) {
                queryInfo = {...queryInfo,
                    fyMonth: query.fyMonth

                }
            }
        }
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/admin/consumedGHGForAdminDashboard/"+ userId +"/"+query.branchId+ new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        
        return Promise.resolve(response.data)
    }
    async getChargerOverallStatus(): Promise<ChargerOverallStatus[]> {
       
        let response = await axios.get(config.api.host + "/admin/chargerOverallStatus", {
            headers: {
                Authorization : new LocalStorage().authToken
            }
        });
        let statusInfos: any[] = response.data.data;
        let statuses: ChargerOverallStatus[] = [];
        statusInfos.forEach((statusInfo) => {
            statuses.push(new ChargerOverallStatus(
                statusInfo.code,
                statusInfo.description,
                "",
                ""
            ))
        });
        return Promise.resolve(statuses);

    }
    async getChargerOtherStatus(): Promise<ChargerOtherStatus[]> {
        let response = await axios.get(config.api.host + "/admin/chargerOtherStatus", {
            headers: {
                Authorization : new LocalStorage().authToken
            }
        });
        let statusInfos: any[] = response.data.data;
        let statuses: ChargerOtherStatus[] = [];
        statusInfos.forEach((statusInfo) => {
            statuses.push(new ChargerOtherStatus(
                statusInfo.code,
                statusInfo.description,
                "",
                ""
            ))
        });
        return Promise.resolve(statuses);

    }
    async getReservatinDetailsForSelectedBranchQuery(query: AdminBranchQuery): Promise<any> {
        
        let queryInfo: any = {}

        if(query) {
            if(query.installationId) {
                queryInfo = {... queryInfo,
                    installationId: query.installationId

                }
            }
            if(query.outputId) {
                queryInfo = {... queryInfo,
                    outputId: query.outputId

                }
            }
            if(query.connectorID) {
                queryInfo = {... queryInfo,
                    connectorId: query.connectorID
                }
            }
        }
        let response = await axios.get(config.api.host + "/admin/reservationDetailsForSelectedBranch" + new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data.data)
    }

    // async getCustomerVisitCountChartData(branchId: any): Promise<any> {
    //     let userId =  localStorage.getItem("user.id")
    //     let response = await axios.get(config.api.host + "/admin/coustomerVisitCountForAdminDashboard/"+userId+"/"+branchId, {
    //         headers: {
    //             Authorization: new LocalStorage().authToken
    //         }
    //     })
        
    //     return Promise.resolve(response.data)
    // }

    async getCustomerVisitCountChartData(query: customerVisitQuery): Promise<any> {
        let queryInfo: any = {

        }
        if(query) {
            if(query.branchId != null) {
                queryInfo = {... queryInfo,
                    branchId: query.branchId

                }
            }
            
            if(query.stationId != null) {
                queryInfo = {... queryInfo,
                    stationId: query.stationId
                }
            }
            if(query.outputId != null) {
                queryInfo = {...queryInfo,
                    outputId: query.outputId

                }
            }
            if(query.filterId != null) {
                queryInfo = {...queryInfo,
                    filterId: query.filterId

                }
            }
            if(query.fyYear != null) {
                queryInfo = {...queryInfo,
                    fyYear: query.fyYear

                }
            }
            if(query.fyMonth != null) {
                queryInfo = {...queryInfo,
                    fyMonth: query.fyMonth

                }
            }
        }
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/admin/coustomerVisitCountForAdminDashboard/"+userId+"/"+ new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        
        return Promise.resolve(response.data)
    }
    
    // async getTransactionCountChartData(branchId: any): Promise<any> {
    //     let userId =  localStorage.getItem("user.id")
    //     let response = await axios.get(config.api.host + "/admin/transactionCountForAdminDashboard/"+userId+"/"+branchId, {
    //         headers: {
    //             Authorization: new LocalStorage().authToken
    //         }
    //     })
        
    //     return Promise.resolve(response.data)
    // }

    async getTransactionCountChartData(query: customerVisitQuery): Promise<any> {
        let queryInfo: any = {

        }
        if(query) {
            if(query.branchId != null) {
                queryInfo = {... queryInfo,
                    branchId: query.branchId

                }
            }
            
            if(query.stationId != null) {
                queryInfo = {... queryInfo,
                    stationId: query.stationId
                }
            }
            if(query.outputId != null) {
                queryInfo = {...queryInfo,
                    outputId: query.outputId

                }
            }
            if(query.filterId != null) {
                queryInfo = {...queryInfo,
                    filterId: query.filterId

                }
            }
            if(query.fyYear != null) {
                queryInfo = {...queryInfo,
                    fyYear: query.fyYear

                }
            }
            if(query.fyMonth != null) {
                queryInfo = {...queryInfo,
                    fyMonth: query.fyMonth

                }
            }
        }

        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/admin/transactionCountForAdminDashboard/"+userId+"/"+ new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        
        return Promise.resolve(response.data)
    }
    
    // async getRevenueCountChartData(query: customerVisitQuery): Promise<any> {
    //     let userId =  localStorage.getItem("user.id")
    //     let response = await axios.get(config.api.host + "/admin/revenueCountForAdminDashboard/"+userId+"/"+branchId, {
    //         headers: {
    //             Authorization: new LocalStorage().authToken
    //         }
    //     })
        
    //     return Promise.resolve(response.data)
    // }

    async getRevenueCountChartData(query: customerVisitQuery): Promise<any> {
        let queryInfo: any = {

        }
        if(query) {
            if(query.branchId != null) {
                queryInfo = {... queryInfo,
                    branchId: query.branchId

                }
            }
            
            if(query.stationId != null) {
                queryInfo = {... queryInfo,
                    stationId: query.stationId
                }
            }
            if(query.outputId != null) {
                queryInfo = {...queryInfo,
                    outputId: query.outputId

                }
            }
            if(query.filterId != null) {
                queryInfo = {...queryInfo,
                    filterId: query.filterId

                }
            }
            if(query.fyYear != null) {
                queryInfo = {...queryInfo,
                    fyYear: query.fyYear

                }
            }
            if(query.fyMonth != null) {
                queryInfo = {...queryInfo,
                    fyMonth: query.fyMonth

                }
            }
        }

        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/admin/revenueCountForAdminDashboard/"+userId+"/"+ new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        
        return Promise.resolve(response.data)
    }

    async getConsumedEnergeyChartDataForCPO(branchId: any): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        // if(branchId != "") {
        let response = await axios.get(config.api.host + "/corporate/consumedGHGForCPODashboard/"+userId+"/"+branchId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
        
        // return Promise.resolve(data)
        
    }
    async getCustomerVisitCountChartDataForCPO(branchId: any): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/corporate/coustomerVisitCountForCPOAdminDashboard/"+userId+"/"+branchId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        
        return Promise.resolve(response.data)
    }
    async getTransactionCountChartDataForCPO(branchId: any): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/corporate/transactionCountForCPOAdminDashboard/"+userId+"/"+branchId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        
        return Promise.resolve(response.data)
    }
    async getRevenueCountChartDataForCPO(branchId: any): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/corporate/revenueCountForCPOAdminDashboard/"+userId+"/"+branchId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        
        return Promise.resolve(response.data)
    }
    
    async getReportList(branchId: any, stationId: any): Promise<any> {
        let userId =  localStorage.getItem("user.id");
        let roleId = localStorage.getItem("user.roleId")
        let response = await axios.get(config.api.host + "/corporate/"+userId+"/reportList/"+roleId + "/"+branchId+"/"+stationId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }

    async getConfigValueOfDateAndMonth(): Promise<any> {
        let response = await axios.get(config.api.host + "/corporate/monthAndDaysForReport", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }

    async getUsageReportQuery(query: UsageReportQuery): Promise<any> {
        let queryInfo: any = {}
        let userId =  localStorage.getItem("user.id")
        if(query) {
            if(query.mobile) {
                queryInfo = {... queryInfo,
                    mobile: query.mobile

                }
            }
            if(query.branchId) {
                queryInfo = {... queryInfo,
                    branchId: query.branchId

                }
            }
            if(query.fromDate) {
                queryInfo = {... queryInfo,
                    fromDate: query.fromDate
                }
            }
            if(query.toDate) {
                queryInfo = {... queryInfo,
                    toDate: query.toDate
                }
            }
            if(query.reportTypeCode) {
                queryInfo = {... queryInfo,
                    reportTypeCode: query.reportTypeCode
                }
            }
            if(query.vehicleNo) {
                queryInfo = {... queryInfo,
                    vehicleNo: query.vehicleNo
                }
            }
            if(query.branchName !== undefined) {
                queryInfo = {... queryInfo,
                    branchName: query.branchName
                }
            }if(query.stationName !== undefined) {
                queryInfo = {... queryInfo,
                    stationName: query.stationName
                }
            }
            if(query.stationId !== undefined) {
                queryInfo = {... queryInfo,
                    stationId: query.stationId
                }
            }
            if(query.chargerId !== undefined) {
                queryInfo = {... queryInfo,
                    chargerId: query.chargerId
                }
            }
            if(query.outputId !== undefined) {
                queryInfo = {... queryInfo,
                    outputId: query.outputId
                }
            }
            if(query.chargerType !== undefined) {
                queryInfo = {... queryInfo,
                    chargerType: query.chargerType
                }
            }
            if(query.outputName !== undefined) {
                queryInfo = {... queryInfo,
                    outputName: query.outputName
                }
            }
        }
        let response = await axios.get(config.api.host + "/corporate/"+userId+"/usageReport" + new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }
    async getTransactionAndStatusReportQuery(query: TransactionReportQuery): Promise<any> {
        let queryInfo: any = {}
        let userId =  localStorage.getItem("user.id")
        if(query) {
            if(query.branchId) {
                queryInfo = {... queryInfo,
                    branchId: query.branchId

                }
            }
            if(query.reportCode) {
                queryInfo = {... queryInfo,
                    reportCode: query.reportCode

                }
            }
            if(query.reportId) {
                queryInfo = {... queryInfo,
                    reportId: query.reportId

                }
            }
            if(query.fromDate) {
                queryInfo = {... queryInfo,
                    fromDate: query.fromDate
                }
            }
            if(query.toDate) {
                queryInfo = {... queryInfo,
                    toDate: query.toDate
                }
            }
            if(query.branchName !== undefined) {
                queryInfo = {... queryInfo,
                    branchName: query.branchName
                }
            }if(query.stationName !== undefined) {
                queryInfo = {... queryInfo,
                    stationName: query.stationName
                }
            }
            if(query.stationId !== undefined) {
                queryInfo = {... queryInfo,
                    stationId: query.stationId

                }
            }
            if(query.chargerId !== undefined) {
                queryInfo = {... queryInfo,
                    chargerId: query.chargerId

                }
            }
            if(query.outputId !== undefined) {
                queryInfo = {... queryInfo,
                    outputId: query.outputId

                }
            }
            if(query.chargerType !== undefined) {
                queryInfo = {... queryInfo,
                    chargerType: query.chargerType
                }
            }
            if(query.outputName !== undefined) {
                queryInfo = {... queryInfo,
                    outputName: query.outputName
                }
            }
            if(query.errorCode !== undefined) {
                queryInfo = {... queryInfo,
                    errorCode: query.errorCode
                }
            }
        }
        let response = await axios.get(config.api.host + "/corporate/"+userId+"/reportData" + new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }

    
    async downloadUsagePdfReport(data: any, branchId: string, reportCode: string, reportTypeCode: string): Promise<any> {
     
        let URL = await axios.post(config.api.host + "/corporate/"+branchId+"/downloadReportData/"+reportCode+"/"+reportTypeCode, {
            data: data
        }, { responseType: 'blob'})
        return Promise.resolve(URL)
    }
    async getChargersListForStatusReport(branchId: string,): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let chargerList = await axios.get(config.api.host + "/corporate/"+userId+ "/getChargersList/"+branchId)
        return Promise.resolve(chargerList.data.data)
    }
}

